// extracted by mini-css-extract-plugin
export default {"progressBarWrapper":"fileStorage_progressBarWrapper__F7P6p","progressBarLabel":"fileStorage_progressBarLabel__mTxqQ"};